export default __webpack_public_path__ + "static/media/Brijesh-main.847c9a86.png";